import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "About the Research Center", "id": "about" },
    { "name": "Research Projects", "id": "research-projects" },
    { "name": "Seminars/Conferences/Workshops", "id": "seminars-workshops" },
    { "name": "Research Scholars", "id": "research-scholars" },
    { "name": "Achievements", "id": "achievements" },
    { "name": "Contact", "id": "contact" }
];

const contentData = {
    "about": (
        <>
            <p>This center was established on July 18, 2024, after the eighth Education Council meeting of the university. This center has been established with the objective of conducting academic research, investigations, and training human resources on the pilgrimage sites and temples falling within the 48 Kosa Kurukshetra region. During the three-day national workshop on "Temple and Pilgrimage Management" organized by the university from July 15-17, 2024, after considering the views and suggestions of expert scholars, a proposal to establish the "48 Kosa Kurukshetra Pilgrimage Research and Training Center" was put forward in the concluding session of the workshop. The proposal is as follows:</p>
            <p><strong>Proposal</strong></p>
            <p>"After listening to all the speakers and subject matter experts during the three-day national workshop on 'Temple and Pilgrimage Management' held from July 15 to July 17, 2024, it has come to attention that temples and pilgrimage sites are important not only spiritually but also socially and economically. The number of spiritual travelers among tourists across the country is the highest and is increasing every year. The temples and pilgrimage sites within the 48 Kosi pilgrimage area of Kurukshetra are symbols of Haryana's historical, social, cultural, and spiritual glory. The Government of Haryana consistently encourages the preservation and development of these pilgrimage sites through various projects. There should be academic research based on authentic references of these pilgrimage sites and training of human resources for their preservation, management, development, and promotion.</p>
            <p>48 Kosa Kurukshetra is the land of many pilgrimage sites from the Mahabharata period, having mythological, historical, spiritual, and social significance. Therefore, there is a great need to provide research-based authentic material on the pilgrimage sites and temples falling under it. So far, there has been a lack of research and academic work on this subject, so providing an academic perspective to it is the demand of both time and society. Most of the pilgrimage sites and temples falling under this 48 Kosa Kurukshetra pilgrimage are predominantly in the Kaithal region, so society expects that teachers and research scholars at Maharishi Valmiki Sanskrit University, Kaithal, should research this subject and also train candidates for the preservation and promotion of the pilgrimage sites in the Kaithal region.</p>
            <p>Therefore, after listening and understanding the subjects of all speakers and experts in the workshop, it can be concluded that the '48 Kosa Kurukshetra Pilgrimage Research and Training Center' should be established at Maharishi Valmiki Sanskrit University, Kaithal. This center will introduce pilgrims from all over the world to ancient Indian Vedic culture. At the same time, this center will not only train capable human resources but also contribute to the economic development of the region. With the establishment of this research center, this three-day workshop on 'Temple and Pilgrimage Management' will be established as the auspicious beginning of this divine work. This workshop requests the university to present this proposal for consideration and approval in the Vidvat Parishad meeting to be held on July 18, 2024."</p>
            <p>Currently, this center is continuously striving to achieve its objectives through research, seminars, workshops, publications, and training. The research center has also published a book on Temple and Pilgrimage Management. The first coordinator of this center is Dr. Govind Vallabh.</p>
        </>
    ),
    "research-projects": (
        <>
            <p>Not available.</p>
        </>
    ),
    "seminars-workshops": (
        <>
            <p>1. The three-day national workshop on 'Temple and Pilgrimage Management' held from July 15-17, 2024, formed the cornerstone of this center.</p>
        </>
    ),
    "research-scholars": (
        <>
            <p>Not available.</p>
        </>
    ),
    "achievements": (
        <>
            <p>1. Publication of a book</p>
            <p>Temple and Pilgrimage Management, Editor – Dr. Govind Vallabh, Year 2025</p>
        </>
    ),
    "contact": (
        <>
            <p>Dr. Govind Vallabh</p>
            <p>Coordinator, 48 Kosa Kurukshetra Pilgrimage Research and Training Center</p>
            <p>Mobile No. - 70115-04209</p>
            <p>Email - 48kosktrtc@mvsu.ac.in</p>
        </>
    )
};

export default function KosKurukshetraResearchTrainingCenter_Eng() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [currentContent, setCurrentContent] = useState(contentData["about"]); // Set default content
    const [activeItem, setActiveItem] = useState("about"); // Track active item for styling

    useEffect(() => {
        handleItemClick("about");

        const handleResize = () => {
            if (window.innerWidth >= 768) { // md breakpoint
                setShowSidebar(true);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleItemClick = (deptId) => {
        setCurrentContent(contentData[deptId]);
        setActiveItem(deptId);
        if (window.innerWidth < 768) {
            setShowSidebar(false);
        }
    };

    return (
        <div className="d-flex flex-column flex-md-row vh-100">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ Menu
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">48 Kosa Kurukshetra Pilgrimage Research and Training Center</h5>
                <div className="flex-grow-1">
                    {departments.map((dept) => (
                        <p
                            key={dept.id}
                            className={`mb-1 p-2 bg-white text-dark rounded shadow-sm small cursor-pointer ${activeItem === dept.id ? 'border border-primary' : ''}`}
                            onClick={() => handleItemClick(dept.id)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main
                className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto"
                onClick={() => {
                    if (window.innerWidth < 768 && showSidebar) {
                        setShowSidebar(false);
                    }
                }}
            >
                <h5 className="mb-3">Main Content</h5>
                <div>{currentContent}</div>
            </main>
        </div>
    );
}